<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'订单还款日期'">
              <a-range-picker
                v-model="queryParam.endTime"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                style="width: 100%;"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item :label="'产品类型'">
              <a-select
                v-model='queryParam.appssid'

              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
                <a-button type='primary' @click="downLoadData()" icon='download'
                          style='margin-left: 8px'>{{ $t('exportFile')
                  }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
      >
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </div>
</template>

<script>

import { findRepairedButUnreleasedUsersList, getApplist } from '@/webpublicapi/order'
import vModal from '../modules/Modal';
import moment from 'moment'
import exportFile from '@/api/exportFile'
import DictSelect from '@/views/webpublic/modules/DictSelect.vue'
import { hasRoleCode } from '@/utils/permissions'

const I18N_KEY = 'order.';
export default {
  name: 'loanStatusLoanCount',
  components: {
    DictSelect,
    vModal,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visibleRepayUrlCard: false,
      repayUrl: '',
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataSource: [],
      appList: [],
      // 查询条件
      queryParam: {
        // endTime: [moment().add('days', -1), moment().add('days', 0)],
        endTime: [
          moment().add('days', -1).startOf('day'), // 当前时间往前推一天的开始时间（午夜00:00:00）
          moment().endOf('day') // 当前时间的结束时间（23:59:59）
        ],
        'appssid': '',
      },
      loading: false,
      // 表头
      isorter: {
        column: 'd',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '姓名',
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: '手机号',
          align: 'left',
          dataIndex: 'custMobileNo'
        },
        {
          title: '产品名称(盘号)',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: '订单提交时间',
          align: 'left',
          dataIndex: 'submitTime'
        },
        {
          title: '订单还款时间',
          align: 'left',
          dataIndex: 'updatedTime'
        }
      ]
    },
  },
  created () {
    getApplist().then(res => {
      let filteredData = res.data
      // if(hasRoleCode('tel_market_admin'))
      // {
      //   filteredData = res.data.filter((item, index) =>
      //     index === 0 || (item.appssid && item.appssid.includes("139"))
      //   )
      // }
      this.appList = filteredData || []
    })
    this.loadData(1)
  },
  methods: {
    downLoadData () {
      var params = this.getQueryParams()// 查询条件
      console.log('下载参数',params)
      const file = {
        fileUrl: '/api/web/webpublic/order/findRepairedButUnreleasedUsersListExcel?startDate='
          + params.startDate + '&endDate=' + params.endDate + '&appssid=' + params.appssid ,
          fileName:   "RepairedButUnreleasedUsers" + params.startDate  + params.endDate +'.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      console.log('params--->', params.appssid)

      findRepairedButUnreleasedUsersList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.dataSource = res.data.rows
          this.total = res.data.total
        }else{
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    transformStringToLow (str) {
      return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { endTime } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: (endTime && endTime.length) ? this.transformTime(endTime[0]) : undefined,
        endDate : (endTime && endTime.length) ? moment(this.transformTime(endTime[1]), "YYYY-MM-DD HH:mm:ss").endOf("day").format("YYYY-MM-DD HH:mm:ss") : undefined,
      }
      delete data.endTime;
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return param
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    // 重置字典类型搜索框的内容
    searchReset () {
      var that = this
      that.queryParam.appssid = ''
      that.queryParam.endTime = undefined

    },
    changeModal (visible) {
      this.visible = visible;
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>
